import { useOptimizedRecord } from '@/shared/hooks/useOptimizedQuery'
import { RankingUser } from '@/shared/types/user'

interface Ranking {
  school: RankingUser[]
  team: RankingUser[]
  friends: RankingUser[]
}

export const useRankingStore = () => {
  const { record: ranking, isLoading } = useOptimizedRecord<Ranking>({
    path: '/user/rankings'
  })

  return { ranking, isLoading }
}
